<template>
  <div style="background-color: #000000">
    <myheader
      :backFlag="true"
      :backIntercept="true"
      @childBackEvent="back"
      headTitle="人脸采集"
    ></myheader>
    <div id="scancode" class="scancode all_text_center"></div>
  </div>
</template>

<script>
import {
  Dialog
} from 'vant';
import {
  realLiveAuth,
  initIosAuth
} from '../../utils/nativeRealLiveAuth.js';
import {
  closeCurrentPage
} from '../../utils/nativeOtherOperate.js';
export default {
  data() {
    return {
      //实人，活体认证,扫码签requestId,
      requestId: '',
      //扫码签appCode,
      appCode: '',
    }
  },
  methods: {
    //
    back() {
      closeCurrentPage(0)
    },
    //
    init() {
      let result = this.$route.query.scanCode
      if (result.search('af-') != -1 || result.search('lf-') != -1 || result.search('MOCK-') != -1) {
        //请求接口
        //从result中获取要执行操作的类型和其他信息（requestid或登录，或盖章hash）
        this.getResultType(result)
      } else {
        this.$Toast('不支持当前调用！');
        setTimeout(() => {
          closeCurrentPage(0)
        }, 1000)
      }
      //ios版每次使用前需要初始化
      initIosAuth()
    },
    //根据扫码返回数据获取任务类型和数据
    getResultType(requestId) {
      let type = requestId.substr(0, 3)
      switch (type) {
        case 'MOC':
        //实人认证
        case 'af-':
        //活体认证
        case 'lf-':
          //调用实人认证或活体认证
          this.$store.dispatch(this.$LoadShow, true)
          realLiveAuth({
            type: '3',
            requestId: requestId
          })
          break;
        //扫码跳转合同存证报告
        default:
          this.$Toast('不支持当前调用');
          setTimeout(() => {
            closeCurrentPage(0)
          }, 1000)
          break;
      }
    },
    //扫码签实人、活体认证成功
    scanAuthSucced() {
      this.$store.dispatch(this.$LoadShow, false)
      this.$Toast('认证成功！')
      setTimeout(() => {
        closeCurrentPage(1)
      }, 1000)
    },
    //扫码签实人、活体认证失败
    scanAuthFailed(msg) {
      this.$store.dispatch(this.$LoadShow, false)
      this.$Toast(msg || '认证失败，请重新认证！')
      setTimeout(() => {
        closeCurrentPage(0)
      }, 3000)
    },
  },
  mounted() {
    this.init()
  },
  created() {
    window.scanAuthSucced = this.scanAuthSucced
    window.scanAuthFailed = this.scanAuthFailed
  },
  beforeDestroy() {

  },
  destroyed() { }
}
</script>

<style lang="scss" scoped>
@import "../../styles/global.css";

.scancode {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>